<!-- <div class="row wizardHead"> -->
    <div class="col-12 wizardHead p-0">
        <div class="row">
            <div class="col-112 p-0">
                <div class="row">
                    <div class="col-12 p-0">
                        <h5>{{wizardInput?.title}}</h5>
                    </div>
                    <div class="col-12 p-0">
                        <ul>
                            <li>
                                <label>Task ID: {{wizardInput?.data?.taskId}}</label>
                            </li>
                            <li>
                                <label>Individual: {{wizardInput?.data?.individual}}</label>
                            </li>
                            <li>
                                <label>Petition Type: {{wizardInput?.data?.petitionType}}</label>
                            </li>
                            <li>
                                <label>Status: <span class="status">{{wizardInput?.data?.status}}</span></label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="col-2 saveContinue">
                <button mat-raised-button color="primary">Save & Continue</button>
            </div> -->
        </div>
    </div>
<!-- </div> -->